import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || "#1A73E8"};
  color: ${(p) => (p.color ? "#1A73E8" : "#fff")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 2px solid ${(p) => (p.color ? "#1A73E8" : "transparent")};
  border-radius: 6px;
  padding: 0.75rem 1.5rem;
  cursor: pointer;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 4px 14px rgba(26, 115, 232, 0.15);
  line-height: 1.4;

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 2px solid #00D4FF;
    background-color: #00D4FF;
    box-shadow: 0 6px 20px rgba(0, 212, 255, 0.25);
    transform: translateY(-1px);
  }
`;
